module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA3klEQVQ4jZ3PMW6DMBiG4ZcokThCYWPjIiDVV2Bs1YELwMoAt8g1GDiDr1HTHWFZQrK7JFEgVYj7jb/8PpIDKeU7cAYi/DYCH4GUUsVxHIVh6FUbY1BKjQfAOwa4NNHBu9zMG3DO4Zz7H2CtpW1b+r73B6y1dF2H1po8zx+BZVnQWu/GTdNwOp0egWEYqKqKeZ5fjleAEII0Tanr+obsxSsgCALKsrwh0zTtxitgixRFsRsDHLeHK5IkCVmWPY3/BK6IEOJpeP+F0Rjz0uP7XZqfI/CplDoDb57GN/D1C7nadJvU/8jdAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/common/images/pp19.png
// module id = XpbP
// module chunks = 20